import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskDataSourceService {

  constructor(private http: HttpClient) {}

  getAllTasks(): Promise<any[]> {
    return this.http.get<any[]>(environment.v3BaseUrl + '/api/v3/admin-desktop/all-tasks').toPromise();
  }
} 